import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import api from '../utils/api';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const [policy, setPolicy] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  const fetchPrivacyPolicy = async () => {
    try {
      const response = await api.get('/policies/privacy');
      // API returns { success: true, data: {...}, message: '...' }
      // axios wraps it, so response.data = { success: true, data: {...}, message: '...' }
      const policyData = response.data?.data || null;
      setPolicy(policyData);
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
      setPolicy(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="privacy-policy page-transition">
      <section className="policy-hero">
        <div className="container">
          <motion.div
            className="policy-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="policy-hero-title">Privacy Policy</h1>
            {policy && (
              <p className="policy-version">Version {policy.version}</p>
            )}
          </motion.div>
        </div>
      </section>

      <section className="policy-content">
        <div className="container">
          {isLoading ? (
            <div className="policy-loading">Loading...</div>
          ) : policy ? (
            <motion.div
              className="policy-body"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2 className="policy-title">{policy.title}</h2>
              <div
                className="policy-text"
                dangerouslySetInnerHTML={{ __html: policy.content }}
              />
              {policy.created_at && (
                <p className="policy-date">
                  Last updated: {new Date(policy.updated_at || policy.created_at).toLocaleDateString()}
                </p>
              )}
            </motion.div>
          ) : (
            <div className="policy-empty">
              <p>Privacy Policy not available yet.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;

